/*
 * Slim v5.3.1 - Image Cropping Made Easy
 * Copyright (c) 2020 Rik Schennink - https://pqina.nl/slim
 */
<template>
    <div id="slim-cropper-custom" class="slim">
        <slot></slot>
    </div>
</template>

<script>
  // Slim (place slim CSS and slim.module.js file in same folder as this file)
  import Slim from './slim.module.js'

  var instance = null

  export default {
    props: ['options', 'initalImage'],
    name: 'custom-slim-cropper',
    mounted: function () {
      if (this.options.initialImage) {
        var img = document.createElement('img')
        img.setAttribute('alt', '')
        img.src = this.options.initialImage
        this.$el.appendChild(img)
      }
      instance = new Slim(this.$el, this.options)
    },
    beforeUnmount: function () {
      instance.destroy()
    }
  }
</script>
<style lang="css">
    @import "./slim.min.css";
    #slim-cropper-custom .slim-area .slim-result {
        display: none;
    }
    #slim-cropper-custom .slim-btn-edit {
      display: none;
    }
    #slim-cropper-custom .slim-btn {
      background-image: none !important;
    }
    #slim-cropper-custom.slim img {
      height: 100%;
    }
    #slim-cropper-custom.slim .slim-btn-group {
      overflow: visible;
    }
    #slim-cropper-custom.slim .slim-btn-remove {
      position: absolute;
      top: -115px;
      left: 105px;
      padding: 0 !important;
      width: 20px !important;
      height: 20px !important;
      background-color: #7E84A3 !important;
    }
    #slim-cropper-custom .slim-btn.slim-btn-remove::before {
      content: none !important;
    }
    #slim-cropper-custom.slim .slim-btn-remove i {
      font-size: 14px;
    }
    .slim-crop-area {
      border-radius: 50%;
    }
    .slim-crop-area .slim-crop-mask {
      border-radius: 50%;
    }
</style>
